import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

import CloseIcon from "@mui/icons-material/Close";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

import GppBadIcon from "@mui/icons-material/GppBad";

import { IconButton } from "@mui/material";

export function FailModal({ openSuccess, setOpenSuccess, message }) {
  const handleClose = () => {
    setOpenSuccess(false);
  };

  return (
    <div>
      <Dialog
        open={openSuccess}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          <IconButton onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ p: "40px" }}>
          <DialogContentText
            id="alert-dialog-description"
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <GppBadIcon
              sx={{
                fontSize: "76px",
                color: "#B00020",
                mb: "10px",
                mx: "auto",
              }}
            />
            <span> {message}</span>
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ px: "40px", py: "20px" }}>
          <Button
            sx={{ width: "100%" }}
            variant="contained"
            onClick={handleClose}
          >
            تم
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
